
import Button from '@/components/shared/Button/Button';
import Popup from '@/components/shared/Popup/Popup';
import { POPUPS } from '@/js/AppState';
import PopupsManager from 'react-sdk/PopupsManager';
import classes from './PopupPlaceholder.module.css';



const PopupPlaceholder = () => {

  const data = PopupsManager.getData(POPUPS.PLACEHOLDER)
  const { content, onValid } = data
  
  return (
    <Popup className={classes.PopupPlaceholder}>
      <div className={classes.PopupContent}>
        
        <div className={classes.PopupTitle}>
          <div className={classes.PopupMessage} dangerouslySetInnerHTML={{__html: "Placeholder"}} />
        </div>

        <div className={classes.PopupDesc}>
          <div className={classes.PopupMessage} dangerouslySetInnerHTML={{__html: content}} />
        </div>

        <div className={classes.btn_ctnr}>
          <Button onClick={() => { PopupsManager.close(POPUPS.PLACEHOLDER); onValid?.();}}>Continuer</Button>
        </div>
        
      </div>
    </Popup>
  );
};

export default PopupPlaceholder;
